/** Id of the "Number of Pets Allowed" details field, used when a source can't give field names. */
const PETS_FIELD_ID = '7';

/**
 * How many pets the host said are allowed (the "Number of Pets Allowed" counter on the first
 * screen). `null` means it isn't known (the details were never loaded), so callers should not hide
 * anything; 0 means none.
 */
export const getPetsAllowedCount = (
  offerings: Record<string, any> | null | undefined,
  offeringsMap: Record<string, any> | null | undefined,
): number | null => {
  if (!offerings) return null;
  const entry = Object.entries(offeringsMap || {}).find(([, value]) => {
    const label = typeof value === 'string' ? value : value?.detailsName || value?.name || '';
    return /\bpets?\b/i.test(String(label));
  });
  const raw = entry ? offerings[entry[0]] : offerings[PETS_FIELD_ID];
  if (raw === undefined || raw === null || raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

/** True when the host chose no pets, so pet-related fields should not be shown. */
export const petsNotAllowed = (
  offerings: Record<string, any> | null | undefined,
  offeringsMap: Record<string, any> | null | undefined,
): boolean => getPetsAllowedCount(offerings, offeringsMap) === 0;
